const BotError = ({ message }) => {
    return (
        <p className="grey-container-box-error">
            <div className="error-chat-message">{message}</div>
        </p>
    );
};

export default BotError;
